export default __webpack_public_path__ + "static/media/minEmpError.3b0e0bbb.png";